import { render, staticRenderFns } from "./payGetesTerms.vue?vue&type=template&id=69deb878"
import script from "./payGetesTerms.vue?vue&type=script&lang=js"
export * from "./payGetesTerms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports